<app-page-layout>
    <page-body>
        @if (organization(); as organization) {
            @if (organization.establishments.length === 0) {
                <app-establishment-empty-state />
            } @else {
                <div>
                    <h3 class="text-base font-semibold leading-6 text-gray-900 pb-5">
                        Selecteer een vestiging
                    </h3>
                    <app-establishment-picker
                        [establishments]="organization.establishments"
                    />
                </div>
            }
        }
    </page-body>
</app-page-layout>
